import * as React from 'react'
import { requestWpsData } from '../../utils/requestWpsData'
import { Args, getWidgetProps, Widget, withArgs, WPSClient } from '@utils'
import { StringBundle } from '../../components/localizer/localizer'
import { Provider } from 'react-redux'
import { AtfComponent } from './component'
import {
  normalizeGetStrings,
  normalizeGetPreferences,
  normalizeGetDetailPage,
  NormalizeGetDetailPageType,
  NormalizeGetStringsType,
  NormalizeGetPreferencesType
} from '../../data/normalize'
import { configureStore } from '../../store'
import { IDetailPageState } from '../../reducers'
import { safeBoolean } from '../../utils/utils'
import { ErrorBoundary } from '../../components/error/ErrorBoundary'
import { GetAtfInput, getAtfInput } from '../../data/getDetailPageInputs'
import { DVUI } from '@amzn/dvui/dist/DVUI'
import { DPPlaybackArea } from '../../utils/DPPlaybackArea'
import { PurchaseFlowWrapper } from '../../components/purchaseFlowWrapper/purchaseFlowWrapper'

export type AtfProps = {
  state: NormalizeGetDetailPageType &
    NormalizeGetStringsType &
    NormalizeGetPreferencesType &
    Pick<IDetailPageState, 'features'>
  isPageChange?: boolean
}

export const getProps: getWidgetProps<AtfProps> = async ({ context, titleID, isCrow, isElcano,
                                                           atfTreatment, isStarlightEnhanced }, api) => {
  const operation = (wpsClient: WPSClient) => {
    const args: GetAtfInput = { context, titleID, isCrow: safeBoolean(isCrow), isElcano: safeBoolean(isElcano) }
    return wpsClient.GetDetailPage(getAtfInput(args))
  }

  const wpsData = await requestWpsData({
    context,
    api,
    operation,
    stringBundle: StringBundle.ATF,
    requestPreferences: true
  })

  return {
    state: {
      features: {
        isElcano: safeBoolean(isElcano),
        isStarlightEnhanced: safeBoolean(isStarlightEnhanced),
        atfTreatment: atfTreatment
      },
      ...normalizeGetStrings(wpsData.stringsResponse!),
      ...normalizeGetPreferences(wpsData.preferencesResponse!),
      ...normalizeGetDetailPage(titleID, wpsData.operationResponse)
    }
  }
}

const AtfWidget = (props: AtfProps & Args) => {
  const { logger, context: requestContext, state, isPageChange } = props
  const store = configureStore({ ...state, requestContext }, logger, isPageChange)

  return (
    <DVUI>
      <Provider store={store}>
        <ErrorBoundary name='atf'>
          <DPPlaybackArea>
            <AtfComponent />
          </DPPlaybackArea>
        </ErrorBoundary>
        <PurchaseFlowWrapper />
      </Provider>
    </DVUI>
  )
}

export const Atf: Widget<AtfProps> = {
  name: 'detail-atf',
  getProps: global.__SERVER__ === true ? getProps : undefined,
  Component: withArgs(AtfWidget) as React.ComponentType<any>
}
